module.exports = __webpack_public_path__ + "media/application/images/svgs/sunrise-73854791b612dc114e9f21685544e0c1.svg";